// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-button {
    background-color: #ffffff;
    color: rgb(0, 0, 0);
  
    border: 2px solid #fcfcfc;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 15px;
    transition: background-color 0.3s ease;
  }
  
  .download-button:hover {
    background-color: #e6f3ff;
  }
  
  .details-button {
    background-color: #ffa500;
  }

  .download-button-s {
    background-color: #f1c9c9;
    color: rgb(0, 0, 0);
  
    border: 2px solid #975252;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 15px;
    transition: background-color 0.3s ease;
  }
  
  .download-button-s:hover {
    background-color: #f5a7ce;
  }
  
  .details-button-s {
    background-color: #ffa500;
  }

  .download-button-g {
    background-color: #a5ecbb;
    color: rgb(0, 0, 0);
  
    border: 2px solid #8bb380;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 15px;
    transition: background-color 0.3s ease;
  }
  
  .download-button-g:hover {
    background-color: #90cabc;
  }
  
  .details-button-g {
    background-color: #ffa500;
  }


  .download-button-f {
    background-color: #a5e1ec;
    color: rgb(0, 0, 0);
  
    border: 2px solid #79e6e0;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 15px;
    transition: background-color 0.3s ease;
  }
  
  .download-button-f:hover {
    background-color: #c2cdff;
  }
  
  .details-button-f {
    background-color: #ffa500;
  }


  `, "",{"version":3,"sources":["webpack://./src/components/restinfo/email.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,yBAAyB;IACzB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".download-button {\r\n    background-color: #ffffff;\r\n    color: rgb(0, 0, 0);\r\n  \r\n    border: 2px solid #fcfcfc;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .download-button:hover {\r\n    background-color: #e6f3ff;\r\n  }\r\n  \r\n  .details-button {\r\n    background-color: #ffa500;\r\n  }\r\n\r\n  .download-button-s {\r\n    background-color: #f1c9c9;\r\n    color: rgb(0, 0, 0);\r\n  \r\n    border: 2px solid #975252;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .download-button-s:hover {\r\n    background-color: #f5a7ce;\r\n  }\r\n  \r\n  .details-button-s {\r\n    background-color: #ffa500;\r\n  }\r\n\r\n  .download-button-g {\r\n    background-color: #a5ecbb;\r\n    color: rgb(0, 0, 0);\r\n  \r\n    border: 2px solid #8bb380;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .download-button-g:hover {\r\n    background-color: #90cabc;\r\n  }\r\n  \r\n  .details-button-g {\r\n    background-color: #ffa500;\r\n  }\r\n\r\n\r\n  .download-button-f {\r\n    background-color: #a5e1ec;\r\n    color: rgb(0, 0, 0);\r\n  \r\n    border: 2px solid #79e6e0;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .download-button-f:hover {\r\n    background-color: #c2cdff;\r\n  }\r\n  \r\n  .details-button-f {\r\n    background-color: #ffa500;\r\n  }\r\n\r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
